import {Component, ViewChild, AfterViewInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {AppService} from '@api';
import {SistemaService} from '@servicios/Sistema.Service';

import {AlertaEnum, DialogoEnum} from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import {MensajeService} from '@mensaje/Mensaje.Service';
import {RespuestaEstatusEnum} from '@enumeraciones/Enumeraciones.enum';

import {FiltrosComponent} from '@componentes/Filtros/Filtros.component';
import {FiltroModel} from '@componentes/Filtros/Filtro.model';
import {TipoFiltroEnum} from '@componentes/Filtros/Filtros.enum';

import {Criterio} from '@modelo/catalogo/Criterio.model';

@Component(
    {
        selector: 'criterio',
        templateUrl: './criterio.template.html',
        styleUrls: ['./criterio.component.scss']
    })

export class CriterioComponent implements AfterViewInit {
    dataTable!: Array<any>;
    dataTableInactivos!: Array<any>;

    public entidad: Criterio;

    public abierto!: boolean;
    public animacion!: string;
    public errorActivo!: boolean;

    @ViewChild(FiltrosComponent) filtrosComponent!: FiltrosComponent;
    filtrosDisplay: Array<FiltroModel> = [];
    uriApi: string

    SelCompetencia: any[];

    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService) {
        this.entidad = new Criterio();
        this.uriApi = "configuracion/criterio/buscar";
        this.SelCompetencia = [];
        this.GenerarFiltros()

        this.onReorder = this.onReorder.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);
    }

    ngAfterViewInit() {
        this.setCompetencia()
        this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
    }

    GenerarFiltros() {
        let filtrosDisplay: Array<FiltroModel> = [];

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.Input,
                    Titulo: 'Nombre corto',
                    Obligatorio: false,
                    MensajeError: "",
                    Propiedad: 'nombre'
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Competencia',
                    DisplayValor: 'nombre',
                    ValorName: 'competenciaid',
                    Opciones: this.SelCompetencia,
                    Propiedad: "competenciaid",
                    Obligatorio: false,
                    Buscar: true
                })
        );

        filtrosDisplay.push(
            new FiltroModel(
                {
                    TipoFiltro: TipoFiltroEnum.DropDown,
                    Titulo: 'Activo',
                    DisplayValor: 'nombre',
                    ValorName: 'valor',
                    Opciones: [{nombre: "Sí", valor: true}, {nombre: "No", valor: false}],
                    Propiedad: "activo",
                    Obligatorio: false,
                    Buscar: false
                })
        );

        this.filtrosDisplay = filtrosDisplay;
    }

    setCompetencia() {
        this.appService.Post("configuracion/competencia/buscar", {activo: 1}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.SelCompetencia = res.data
                let filtro = this.filtrosComponent.filtros.find(x => x.ValorName == 'competenciaid');
                if (filtro) {
                    filtro.Opciones = this.SelCompetencia;
                }
            }
        });
    }

    SetDatos(data: any) {
        this.dataTable = data;
    }

    Editar(e: Criterio) {
        this.entidad = new Criterio(e);
        this.Modal();
    }

    Modal() {
        this.animacion = this.sistemaService.animacionAbirModal;
        this.abierto = true;
        this.errorActivo = false;
    }

    CerrarModal() {
        this.entidad = new Criterio();
        this.animacion = this.sistemaService.animacionCerrarModal;

        setTimeout(() => {
            this.abierto = false;
        }, 310);
    }

    Guardar() {
        this.errorActivo = true;

        if (!this.entidad.competenciaid) {
            return this.mensajeService.Alerta(AlertaEnum.Warning, "Ingrese una competencia");
        }
        if (!this.entidad.nombre || !this.entidad.nombre.trim()) {
            return this.mensajeService.Alerta(AlertaEnum.Warning, "Ingrese un nombre");
        }
        if (!this.entidad.descripcion || !this.entidad.descripcion.trim()) {
            return this.mensajeService.Alerta(AlertaEnum.Warning, "Ingrese una descripcón");
        }

        let data = new Criterio(this.entidad)
        this.appService.Post("configuracion/criterio", data).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                this.CerrarModal();
                this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
            }
        })
    }

    Eliminar(e: Criterio) {
        let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar el registro? <br> Esta acción no se podra deshacer.', opciones).then(res => {
            if (res == 1) {
                this.appService.Delete("configuracion/criterio/" + e.criterioid).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                        this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
                    }
                })
            }
        })
    }

    onCellPrepared(e: any) {
        if (e.column.type == "drag" && e.rowType == "data" && !e.data.activo) {
            e.cellElement.style.visibility = 'hidden';
        }
    }

    onDragStart(e: any) {
        this.dataTableInactivos = this.dataTable.filter(x => !x.activo);
        this.dataTable = this.dataTable.filter(x => x.activo);

    }
    onDragEnd(e: any) {
        const visibleRows = e.component.getVisibleRows();
        const toIndex = this.dataTable.findIndex((item) => item.criterioid === visibleRows[e.toIndex].data.criterioid);
        const fromIndex = this.dataTable.findIndex((item) => item.criterioid === e.itemData.criterioid);

        if (toIndex == -1 || this.dataTable[toIndex].competenciaid != this.dataTable[fromIndex].competenciaid) {
            this.mensajeService.Alerta(AlertaEnum.Warning, "Solo se puede ordenar criterios de la misma competencia");
            e.cancel = true;
        }
    }

    onReorder(e: any) {
        const dataCone: Criterio[] = [];
        this.dataTable.forEach(val => dataCone.push(Object.assign({}, val)));

        const visibleRows = e.component.getVisibleRows();
        const toIndex = this.dataTable.findIndex((item) => item.criterioid === visibleRows[e.toIndex].data.criterioid);
        const fromIndex = this.dataTable.findIndex((item) => item.criterioid === e.itemData.criterioid);

        this.dataTable.splice(fromIndex, 1);
        this.dataTable.splice(toIndex, 0, e.itemData);
        this.setOrden(e.itemData.competenciaid);

        let opciones = this.sistemaService.GetOpcionesConfirmar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Deseas guardar el orden?', opciones).then(res => {
            if (res == 1) {
                let dataOrdenada = this.dataTable.map((x: Criterio) => {
                    return {criterioid: x.criterioid, orden: x.orden}
                })
                this.appService.Put("configuracion/criterio", dataOrdenada).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                        //this.filtrosComponent.Consultar(this.filtrosComponent.filtros);
                    }
                }).catch(err => {
                    this.dataTable = [...dataCone, ... this.dataTableInactivos];
                })

                this.dataTable = [...this.dataTable, ... this.dataTableInactivos];
            } else {
                this.dataTable = [...dataCone, ... this.dataTableInactivos];
            }
        })

    }

    setOrden(competenciaid: number) {
        let a = this.dataTable.filter(x => x.competenciaid == competenciaid).forEach((x: Criterio, i: number) => {
            x.orden = i + 1;
        })
    }
}
